import { Injectable } from '@angular/core';
import { Settings } from '../../settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsService } from 'research.web.settings';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class ApiHttpService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient, settingsService : SettingsService) { 
    this.apiUrl = settingsService.get<Settings>('_appSettings').apiUrl;
  }

  public get = <T>(resourcePath: string, params?: {[key: string]: string | string[]}): Observable<T> => {
    return this.httpClient
      .get<T>(this.absoluteUrl(resourcePath), { params: params || { } })
      .catch(e => this.defaultErrorHandler(e));
  }

  public post = <T>(resourcePath: string, postBody?: any) : Observable<T> => {
    return this.httpClient
      .post<T>(this.absoluteUrl(resourcePath), postBody || { })
      .catch(e => this.defaultErrorHandler(e));;
  }

  public put = <T>(resourcePath: string, putBody?: any) : Observable<T> => {
    return this.httpClient
      .put<T>(this.absoluteUrl(resourcePath), putBody || { } )
      .catch(e => this.defaultErrorHandler(e));;
  }

  public delete = <T>(resourcePath: string) : Observable<T> => {
    return this.httpClient
      .delete<T>(this.absoluteUrl(resourcePath))
      .catch(e => this.defaultErrorHandler(e));;
  }

  public head = <T>(resourcePath: string): Observable<T> => {
    return this.httpClient
      .head<T>(this.absoluteUrl(resourcePath))
      .catch(e => this.defaultErrorHandler(e));;
  }
  
  private defaultErrorHandler(e: any): ErrorObservable {
    console.error(e);
    return Observable.throw(e);
  }

  private absoluteUrl(resourcePath: string){
    return this.apiUrl + `/${resourcePath}`;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/api-http.service.ts